import Ads from "../assets/images/right-ads.png"
import Ads3 from "../assets/images/right-ads3.png";
import Ads4 from "../assets/images/right-ads4.png";
import Ads6 from "../assets/images/right-ads6.png";

import Ban1 from "../assets/images/banner/r-banner.gif";
import Ban2 from "../assets/images/banner/r-banner2.gif";
import Ban3 from "../assets/images/banner/r-banner3.gif";
import Ban4 from "../assets/images/banner/r-banner4.gif";

import lBan1 from "../assets/images/banner/l-banner.gif";
import lBan2 from "../assets/images/banner/ls-banner.gif";
import lBan3 from "../assets/images/banner/ls-banner1.gif";

export const ImagesAds = [Ads, Ads3 ,Ads4, Ads6];

export const ImagesBanAds = [Ban1, Ban2 ,Ban3, Ban4];

export const ImagesLBanAds = [lBan1, lBan2 ,lBan3];